const partners = {
    "coManage": {
        "Simplify": {
            "pricePerMonth": 120,
            "pricePerYear": 1440,
            "totalSites": 125,
            "totalRevenue": 180000
        }
        // Additional co-manage partners can be added here
        // "AnotherPartner": {
        //     "pricePerMonth": X,
        //     "pricePerYear": Y,
        //     "totalSites": Z,
        //     "totalRevenue": W
        // }
    },
    "outsource": {
        // Outsource partners would go here
    },
    "hybrid": {
        // Hybrid partners would go here
    }
};

export default partners;